import React, { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Grid, Button } from '@mui/material';
import { motion } from 'framer-motion'; // Framer Motion'ı içeri aktarın
import useAuth from './useAuth.js';
import { useNotification } from "../../components/NotificationContext";
import axios from 'axios';
import { useAuth as useAuthContext } from '../../auth/AuthContext';
const AdminPanel = ({ onShowNotification }) => {
  useAuth();
  const {  logout } = useAuthContext();
  const navigate = useNavigate();
  const [activeBoxIndex, setActiveBoxIndex] = useState(null);
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(true);

  const showNotification = useNotification();
  const token = localStorage.getItem('token');
  // Sayfa adları ve yönlendirme yolları
  const boxData = [
    { name: 'Kategoriler', routes: { add: '/admin/category/add', edit: '/admin/category/edit' } },
    { name: 'Ürünler', routes: { add: '/admin/product/add', edit: '/admin/product/edit' } },
    { name: 'Siparişler', routes: { add: '/admin/orders' }, single: true },
    { name: 'Kullanıcılar', routes: { add: '/admin/users' }, single: true },
    { name: 'Ürün İndirimleri', routes: { add: '/admin/discount/add', edit: '/admin/discount/edit' } },
    { name: 'Sezon Ürünleri', routes: { add: '/admin/seasons' }, single: true },
    { name: 'Kuponlar', routes: { add: '/admin/coupon/add', edit: '/admin/coupon/edit' } },
    { name: 'Raporlar', routes: { add: '/admin/reports' }, single: true },
    { name: 'Kargo Ücretleri', routes: { add: '/admin/shipping' }, single: true },
  ];

  // Aktif kutu seçimi işlemi
  const handleBoxClick = (index) => {
    setActiveBoxIndex(activeBoxIndex === index ? null : index);
  };

  const handleAddClick = (index) => {
    if (boxData[index].routes.add) {
      navigate(boxData[index].routes.add);
    } else {
      console.error('Add route is missing for this box.');
    }
  };

  const handleEditClick = (index) => {
    if (boxData[index].routes.edit) {
      navigate(boxData[index].routes.edit);
    } else {
      console.error('Edit route is missing for this box.');
    }
  };
  const handleLogout = () => {
    // Burada oturum açma işlemi yapılır
    localStorage.removeItem('token'); // Token'ı silme
    logout();
    navigate('/'); // Login sayfasına yönlendirme
    showNotification('Çıkış Yapıldı!', 'success');
    localStorage.setItem('notificationSeverity', 'success');
  };
  
  const fetchStatus = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/users/status/admin`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      setStatus(response.data.durum);
      setLoading(false);
    } catch (err) {
      console.error('Durum verisi alınamadı:', err);
    }
  };

  useEffect(() => {
    fetchStatus();
  }, []);

  return (
    <>
          <Box
        sx={{

          bgcolor: 'rgba(0, 0, 0, 0.5)',
          padding: 2,
        }}
      >
      <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',

        mb: 6
      }}
    >
      <Typography variant="subtitle1" sx={{ color: status === 'aktif' ? 'lightgreen' : 'red', ml:5 }}>
        Sistem Durumu: {loading ? 'Yükleniyor...' : status === 'aktif' ? 'Açık' : 'Kapalı'}
      </Typography>

      <Typography variant="h2" sx={{ color: '#fff' }}>
        Admin Panel
      </Typography>
      
      <Button
          variant="contained"
          color="error"
          onClick={handleLogout}
          sx={{
            bgcolor: '#f44336', // Kırmızı renk
            border: '1px solid #D32F2F',
            mr:5,
            px:4
          }}
        >
          Çıkış Yap
        </Button>
    </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',

          height: '80vh',
          padding: 2,
        }}
      >


        {/* Sayfa Kutuları */}
        <Grid container spacing={2} sx={{ width: '100%' }} justifyContent="center">
          {boxData.map((box, index) => (
            <Grid  size={{ xs: 12, sm: 6,md:4, lg:3 }} key={index}>
              <motion.div
                onClick={() => handleBoxClick(index)}
                whileHover={{ scale: 1.05 }} // Hover animasyonu
                transition={{ duration: 0.3 }}
              >
                <Box
                  sx={{
                    width: "100%",
                    height: 100,
                    bgcolor: 'rgba(0, 0, 0, 0.3)',
                    borderRadius: 2,
                    boxShadow: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '1px solid #ccc',
                    cursor: 'pointer',
                  }}
                >
                  <Typography variant="h6" sx={{ color: '#fff', textShadow: '1px 1px 2px rgba(0, 0, 0, 0.7)' }}>
                    {box.name}
                  </Typography>
                </Box>
              </motion.div>
              {activeBoxIndex === index && (
                <Box
                  sx={{
                    marginTop: 1,
                    display: 'flex',
                    justifyContent: box.single ? 'center' : 'space-around',
                  }}
                >
                  {box.single ? (
                    <Button
                      variant="contained"
                      onClick={() => handleAddClick(index)} // Hem "Ekle" hem de "Görüntüle" işlemi burada yapılacak
                      sx={{
                        bgcolor: 'rgba(25, 118, 210, 0.8)',
                        border: '1px solid #1976D2',
                        flex: 1,
                        margin: '0 5px',
                        animation: 'fadeInMove 0.5s ease-out',
                      }}
                    >
                    {box.name === 'Siparişler' || box.name === 'Kullanıcılar' || box.name === 'Raporlar' ? 'Görüntüle' : 'Ekle' || box.name === 'Kargo Ücretleri' ? 'Düzenle' : 'Ekle' || box.name === 'Sezon Ürünleri' ? 'Düzenle' : 'Ekle'}

                    </Button>
                  ) : (
                    <>
                      <Button
                        variant="contained"
                        onClick={() => handleAddClick(index)}
                        sx={{
                          bgcolor: 'rgba(25, 118, 210, 0.8)',
                          border: '1px solid #1976D2',
                          flex: 1,
                          margin: '0 5px',
                          animation: 'fadeInMove 0.5s ease-out',
                        }}
                      >
                        Ekle
                      </Button>
                      <Button
                        variant="contained"
                        onClick={() => handleEditClick(index)}
                        sx={{
                          flex: 1,
                          bgcolor: 'rgba(156, 39, 176, 0.8)',
                          border: '1px solid #9C27B0',
                          margin: '0 5px',
                          animation: 'fadeInMove 0.5s ease-out',
                        }}
                      >
                        Düzenle
                      </Button>
                    </>
                  )}
                </Box>
              )}
            </Grid>
          ))}
        </Grid>

        {/* Animasyon Tanımları */}
        <style>
          {`
            @keyframes fadeInMove {
              0% {
                opacity: 0;
                transform: translateY(20px);
              }
              100% {
                opacity: 1;
                transform: translateY(0);
              }
            }

            @keyframes slideFadeIn {
              0% {
                transform: translateY(50px);
              }
              100% {
                transform: translateY(0);
              }
            }
          `}
        </style>
      </Box>
    </Box>
    </>
  );
};

export default AdminPanel;
